import { memo } from "react";

interface PlanStatusCheckIconProps {
  className?: string;
  bgColour: string;
  checkColour?: string;
}

/** Filled green circle with a checkmark, used inside the plan status circle. */
export const PlanStatusCheckIcon = memo(function PlanStatusCheckIcon({
  bgColour,
  className,
  checkColour = "black",
}: PlanStatusCheckIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      {/* Explicit circle gives the outer edge a pixel-perfect, crisp boundary */}
      <circle cx="11.5" cy="12" r="9.75" fill={bgColour} />
      {/* Checkmark path only — no outer circle so the crisp circle above shows cleanly */}
      <path
        d="M15.7806 10.2806L10.5306 15.5306C10.461 15.6004 10.3783 15.6557 10.2872 15.6934C10.1962 15.7312 10.0986 15.7506 10 15.7506C9.90144 15.7506 9.80385 15.7312 9.7128 15.6934C9.62175 15.6557 9.53903 15.6004 9.46938 15.5306L7.21938 13.2806C7.07865 13.1399 6.99959 12.949 6.99959 12.75C6.99959 12.551 7.07865 12.3601 7.21938 12.2194C7.36011 12.0786 7.55098 11.9996 7.75 11.9996C7.94903 11.9996 8.1399 12.0786 8.28063 12.2194L10 13.9397L14.7194 9.21937C14.7891 9.14969 14.8718 9.09442 14.9628 9.0567C15.0539 9.01899 15.1515 8.99958 15.25 8.99958C15.3486 8.99958 15.4461 9.01899 15.5372 9.0567C15.6282 9.09442 15.7109 9.14969 15.7806 9.21937C15.8503 9.28906 15.9056 9.37178 15.9433 9.46283C15.981 9.55387 16.0004 9.65145 16.0004 9.75C16.0004 9.84855 15.981 9.94613 15.9433 10.0372C15.9056 10.1282 15.8503 10.2109 15.7806 10.2806Z"
        fill={checkColour}
      />
    </svg>
  );
});
